'use strict';

angular.module('ntmApp').factory('ProfileInfor', function () {

    function ProfileInfor() {

        var self = this;

        self.getInfor = function () {
            return;
        };

    }

    return (ProfileInfor);
});